import { Box, Collapse, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import ActivityTypeBadge from './ActivityTypeBadge';
import ActivityDetailPanel from './ActivityDetailPanel';
import { formatActivityDate, getActivitySummary, getActivitySymbol } from './activityHelpers';

const ActivityRow = ({ activity, index, expanded, onToggle }) => {
    const symbol = getActivitySymbol(activity);
    const summary = getActivitySummary(activity);

    return (
        <>
            <TableRow
                hover
                sx={{
                    cursor: 'pointer',
                    '& td': { borderBottom: expanded ? 'none' : undefined },
                }}
                onClick={onToggle}
            >
                <TableCell sx={{ color: '#fff', width: 48, fontVariantNumeric: 'tabular-nums' }}>
                    {index + 1}
                </TableCell>
                <TableCell sx={{ color: '#fff', whiteSpace: 'nowrap', minWidth: 160 }}>
                    {formatActivityDate(activity.createdAt)}
                </TableCell>
                <TableCell sx={{ minWidth: 120 }}>
                    <ActivityTypeBadge activityType={activity.activity_type} />
                </TableCell>
                <TableCell sx={{ minWidth: 100 }}>
                    {symbol ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box
                                component="img"
                                alt={symbol}
                                src={`https://lcw.nyc3.cdn.digitaloceanspaces.com/production/currencies/64/${symbol.toLowerCase()}.png`}
                                sx={{ width: 24, height: 24, borderRadius: '50%' }}
                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
                                {symbol}
                            </Typography>
                        </Box>
                    ) : (
                        <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>—</Typography>
                    )}
                </TableCell>
                <TableCell sx={{ color: '#fff', maxWidth: 520 }}>
                    <Typography sx={{ fontSize: 13, lineHeight: 1.45, fontVariantNumeric: 'tabular-nums' }}>
                        {summary}
                    </Typography>
                </TableCell>
                <TableCell sx={{ width: 48, pr: 1 }} align="right">
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggle();
                        }}
                        sx={{ color: '#fff' }}
                        aria-label={expanded ? 'Collapse details' : 'Expand details'}
                    >
                        {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={6} sx={{ py: 0, bgcolor: 'primary.light', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Box sx={{ py: 2, px: { xs: 1, md: 2 } }}>
                            <ActivityDetailPanel activity={activity} />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default ActivityRow;
